import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RoomAclEffects } from './room-acl.effects';
import { roomAclReducer } from './room-acl.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('roomAcls', roomAclReducer),
    EffectsModule.forFeature([RoomAclEffects]),
  ],
  providers: [],
})
export class RoomAclStoreModule {}
